import { ApplicationRef, Component } from '@angular/core';
import { DialogosService } from './nucleo/utilidades/dialogos.service';
import { SwUpdate } from '@angular/service-worker';
import { first } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  title = 'atlas-frontend';

  constructor(
    private _dialogosService: DialogosService,
    private _updates: SwUpdate,
    private _appRef: ApplicationRef,
  ) {
    // Buscar actualizaciones de la aplicación
    if (this._updates.isEnabled) this.buscarActualizaciones();
    else console.error('Actualizaciones automáticas desactivadas');
  }

  /**
   * Busca actualizaciones de la aplicación.
   * @author Juan Corral
   */
  private buscarActualizaciones(): void {
    console.log(
      'Esperando a que la aplicación se estabilice para buscar actualizaciones...',
    );

    this._appRef.isStable
      .pipe(first((estable) => estable === true))
      .subscribe(async () => {
        console.log('Aplicación estable, buscando actualizaciones...');

        const encontrada = await this._updates.checkForUpdate();

        // Si no se ha encontrado una actualización, volver a comprobar en 10 minutos
        if (!encontrada) {
          console.log('No se ha encontrado una actualización.');
          setTimeout(() => this.buscarActualizaciones(), 10 * 60 * 1000);
          return;
        }

        // Si se ha encontrado una actualización, notificar al usuario
        console.log('Actualización encontrada.');
        await this._dialogosService.abrirDialogo$(
          'Actualización disponible',
          'Se ha encontrado una nueva versión de la aplicación. ¿Desea actualizar?',
          'Actualizar',
          undefined,
          false,
        );
        this._updates.activateUpdate().then(() => window.location.reload());
      });

    this._updates.versionUpdates.subscribe((evt) => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          console.log(`Detectada nueva versión: ${evt.version.hash}`);
          break;
        case 'VERSION_READY':
          console.log(`Versión actual: ${evt.currentVersion.hash}`);
          console.log(`Nueva versión disponible: ${evt.latestVersion.hash}`);
          break;
        case 'VERSION_INSTALLATION_FAILED':
          console.log(
            `Instalación de la versión ${evt.version.hash} fallida: ${evt.error}`,
          );
          break;
      }
    });
  }
}
